import { auth } from '../base';

export const createCheckoutSession = async (
  priceId,
  userId,
  planName,
  language = 'en',
  billingCycle = 'monthly',
  userEmail = null,
  userName = null,
  extraMetadata = {},
  authEmail = null
) => {
  try {
    const normalizeEmail = (value) => (value || '').trim().toLowerCase();
    const isGuestEmail = (value) => normalizeEmail(value).startsWith('guest_');
    const normalizedAuthEmail = normalizeEmail(authEmail || userEmail);
    const normalizedCheckoutEmail = normalizeEmail(userEmail);

    if (!userId || !normalizedAuthEmail || isGuestEmail(normalizedAuthEmail)) {
      throw new Error('AUTH_REQUIRED');
    }

    if (normalizedCheckoutEmail && isGuestEmail(normalizedCheckoutEmail)) {
      throw new Error('AUTH_REQUIRED');
    }

    if (normalizedAuthEmail && normalizedCheckoutEmail && normalizedAuthEmail !== normalizedCheckoutEmail) {
      throw new Error('EMAIL_MISMATCH');
    }

    const authUser = auth.currentUser;
    const idToken = authUser ? await authUser.getIdToken(true) : null;

    const response = await fetch('/.netlify/functions/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
      },
      body: JSON.stringify({
        priceId,
        userId,
        planName,
        language,
        billingCycle,
        userEmail,
        userName,
        authEmail: authEmail || userEmail,
        ...extraMetadata,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      const error = new Error(errorData.error || 'Failed to create checkout session');
      if (errorData.code) {
        error.code = errorData.code;
      }
      throw error;
    }

    const { url } = await response.json();
    
    // Redirect to Stripe Checkout
    window.location.href = url;
  } catch (error) {
    throw error;
  }
};

export const createCustomerPortalSession = async (customerId) => {
  try {
    const response = await fetch('/.netlify/functions/create-portal-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        customerId
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to create portal session');
    }

    const { url } = await response.json();
    
    // Redirect to Stripe Customer Portal
    window.location.href = url;
  } catch (error) {
    throw error;
  }
};

export const cancelSubscription = async (subscriptionId, userId) => {
  try {
    const response = await fetch('/.netlify/functions/cancel-subscription', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        subscriptionId,
        userId
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to cancel subscription');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
